import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'
import { Parser } from '../../common'
const WhereToContact = ({ block }) => {
    const { valueLocation } = useApp()
    const localSearchFormBlock = block?.childrens.filter(
        (child) => child.block === 'RechercheLocalForm'
    )
    const restBlock = block?.childrens.filter((child) => child.block !== 'RechercheLocalForm')

    return (
        <div className="baseocom-where-to-contact">
            <h2>Où s'adresser ?</h2>
            {isEmpty(localSearchFormBlock) ? (
                <Parser content_block={block?.childrens} />
            ) : (
                <>
                    <Parser content_block={localSearchFormBlock} />
                    {!isEmpty(valueLocation) ? <Parser content_block={restBlock} /> : null}
                </>
            )}
        </div>
    )
}

export default WhereToContact
